// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// js utility library
import _ from 'lodash';

// class names utility
import cx from 'classnames';
import isServer from '../../../lib/isServer';

// import component from material UI
import Toggle from 'material-ui/Toggle';

// component
import FlatButton from '../c_FlatButton';

// validation
import { validateField } from '../../../modelValidator';

const addButtonStyle = {
  display: 'inline-block',
  width: '165px'
};


export default class CustomTextInputList extends Component {
  static propTypes = {
    // labelling
    id: PropTypes.string,
    className: PropTypes.string,
    'data-id': PropTypes.string,

    // options
    optional: PropTypes.bool,
    showCharacterCount: PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    maxCharLength: PropTypes.number,
    capitalizedSentences: PropTypes.bool,
    requiredLength: PropTypes.number,
    exampleTextArr: PropTypes.array,
    descriptionHead: PropTypes.string,
    description: PropTypes.string,
    descriptionBottom: PropTypes.string,

    // inline styling if they go that way :(
    style: PropTypes.object,
    rootStyle: PropTypes.object,
    errorStyle: PropTypes.object,

    // determining value
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array
    ]),
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array
    ]),

    // validation
    validation: PropTypes.object,
    onErrorChange: PropTypes.func,
    errorText: PropTypes.string,

    // change handling
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  static defaultProps = {
    minLength: 3,
    requiredLength: 0
  }

  constructor(props, context) {
    super(props, context);

    // needed internally by material-ui
    if(!isServer) {
      this.validate = _.debounce(::this.validate, 16); // debounce to eye frame rate
    } else {
      this.validate = ::this.validate;
    }

    // setting initial state
    this.state = {
      focused: false,
      dirty: false,
      passwordShow: false,
      errors: [],
      showExample: false,
      showScript: false,
      values: [],
    };

    // check for initial value
    const initVal = props.hasOwnProperty('value') ? props.value :
      props.hasOwnProperty('defaultValue') ? props.defaultValue : null;

    // run validation
    const hasValidation = this.validate(initVal);

    // if no validaton provided, still mark as dirty if intial value provided
    if(!hasValidation && initVal) { // even without validation, should still set state to dirty if initial value is populated
      _.assign(this.state, {dirty: true});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.value !== nextProps.value) {
      this.validate(nextProps.value);
    }
  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-this.state.errors.length);
    }
  }

  onChange = newVal => {
    // pass to functions
    if(this.props.onChange) this.props.onChange(null, newVal);
    if(this.props.onKeyUp) this.props.onKeyUp(null, newVal);

    // handle validation here if uncontrolled component
    if(!this.props.hasOwnProperty('value')) this.validate(newVal);

  }

  onFocus = value => {
    this.setState({
      ...this.state,
      focused: true
    });
    if(this.props.onFocus) {
      this.props.onFocus(null, value);
    }
  }

  onBlur = newValue => {
    const updateStateObj = {focused: false};
    if(!this.state.dirty) updateStateObj.dirty = true; // set dirty if not already dirty
    this.setState({
      ...this.state,
      ...updateStateObj
    });
    if(this.props.onBlur) {
      this.props.onBlur(null, newValue);
    }
  }

  toggleExample = () =>
    this.setState({
      showExample: !this.state.showExample
    });

  validate(value, additionalStateUpdate) {
    if(this.props.validation) {
      // default value to empty array
      const value = [].concat(this.props.value || []);

      let updateStateObj = {
        errors: validateField(value, this.props.validation)
      };

      // Validation to check mininium items required.
      if (this.props.requiredLength > 0) {
        if (_.filter(value, function(v) { return (typeof v === 'string' && v.length > 0); }).length < this.props.requiredLength) {
            updateStateObj.errors.push(`At least ${this.props.requiredLength} are required.`);
        }
      }

      if(additionalStateUpdate) {
        updateStateObj = {...additionalStateUpdate, ...updateStateObj};
      }

      // emit error change to parent
      const errorCountChange = updateStateObj.errors.length === this.state.errors.length ? null :
        updateStateObj.errors.length - this.state.errors.length;

      if(this.props.onErrorChange && errorCountChange) {
        this.props.onErrorChange(errorCountChange);
      }

      // update local error state
      this.setState({
        ...this.state,
        ...updateStateObj
      });
      return true;
    }
  }

  // allows clearing from parent if needed for some hacky reason
  clear = () => this.onKeyUp(null, null);

  addValue(array) {
    return (event) => {
      if (array.length < this.props.maxLength) {
        array.push('');
        this.onChange(array);
        this.onBlur(array);
      }
    };
  }

  updateValue = (event, index, array, allowToChange = false) => {
    if(array[index] !== event.target.value) {
      const newVal = array.slice();

      // Not allow to type more characters if max reached.
      if (this.props.maxCharLength) {
        if (event.target.value.length >= this.props.maxCharLength) {
            event.preventDefault();
            event.target.value = event.target.value.substring(0, this.props.maxCharLength);
        }
      }

      // capitalized sentences.
      if (this.props.capitalizedSentences && allowToChange) {
        let text = event.target.value;
        text = text.charAt(0).toUpperCase() + text.substr(1);
        text = text.replace(/[\.\?\!]\s+.+?/g, (str) => {
          return str.substr(0, str.length-1) + str.charAt(str.length-1).toUpperCase();
        });
        event.target.value = text;
      }

      newVal[index] = event.target.value;
      this.setState({
        values: newVal,
      })
      return newVal;
    }

    // if nothing has changed just return the old value
    return array;
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const {
      className,
      style,
      rootStyle,
      errorStyle,
      minLength,
      maxLength,
      maxCharLength,
      errorText,
      descriptionBottom,
      onKeyUp, /* eslint no-unused-vars:0 */
      onFocus,  /* eslint no-unused-vars:0 */
      onBlur,   /* eslint no-unused-vars:0 */
      validation, /* eslint no-unused-vars:0 */
      exampleTextArr,
      'data-id': dataId,
      ...unmodifiedProps
    } = this.props;

    const additionalProps = {};

    // get booleans
    let errorStr;
    let errorMessage;
    const isError = (this.state.dirty || this.props.isDirty) && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty

    // handle error state visually
    if(isError) {
      // set error string
      errorStr = (errorText && [errorText] || []).concat(this.state.errors).join(', '); // combine passed in error string and local state errors array
      errorMessage = <div className='error-message'>{errorStr}</div>
    }

    // handle optional state visually
    if (this.props.optional) {
      if(!isError) {
        additionalProps.errorText = '(optional)';
        additionalProps.errorStyle = _.merge({}, errorStyle, {
          color: '#c9c9c9'
        });
      } else {
        additionalProps.errorText = `(optional) ${errorStr}`;
      }
    } else if(isError) {
      additionalProps.errorText = errorStr;
    }

    // default value to empty array
    const value = [].concat(this.props.value || []);

    // add an array of empty string to fill to 'minLength'
    const finalValue = value.concat(new Array(Math.max(minLength - value.length, 0)).fill(''));

    return (
      <div className={`input-list ${className}`}
        style={rootStyle}>
        <div className='description'>
          {
            this.props.descriptionHead
            &&
            <b>
              {this.props.descriptionHead}{this.props.description && ': '}
            </b>
          }
          <span>
            {this.props.description}
          </span>
        </div>
        {
          _.isEmpty(exampleTextArr)
          ?
          <div className='example-toggle-container'></div>
          :
          <div className='example-toggle-container'>
            Example
            <Toggle
              data-id='Script'
              className='example-toggle-icon'
              disableTouchRipple
              disableFocusRipple
              labelPosition='left'
              toggled={this.state.showExample}
              onToggle={this.toggleExample}
              style={{transition: 'none'}}
              elementStyle={{transition: 'none'}}
              trackStyle={{height: '8px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1)'}}
              thumbStyle={{top: '-2px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1), left .2s cubic-bezier(0.23, 1, 0.32, 1), margin .2s cubic-bezier(0.23, 1, 0.32, 1)'}}
            />
          </div>
        }
        {
          this.state.showExample
          &&
          <ul className='example-text-container'>
            {
              exampleTextArr.map(exampleVal => (
                <li className='example-text'>
                  {exampleVal}
                </li>
              ))
            }
          </ul>
        }
        {errorMessage}
        {
          finalValue.map((arrVal, index, arr) => (
            <div className='input-list'>
              <textarea
                data-id={`${this.props.descriptionHead} ${index}`}
                key={index}
                className={cx('input-list-item', {
                  focused: this.state.focused,
                  error: isError,
                  optional: this.props.optional && !isError
                })}
                style={style}
                defaultValue={arrVal}
                onChange={event => this.onChange(this.updateValue(event, index, arr))}
                onBlur={event => this.onBlur(this.updateValue(event, index, arr, true))}
                onFocus={event => this.onFocus(this.updateValue(event, index, arr))}
              />
              {
                maxCharLength
                &&
                <div
                  className='character-count'
                >
                  {`${(this.state.values[index]||'').length}/${maxCharLength}`}
                </div>
              }
            </div>
          ))
        }
        {
          (
            !maxLength
            ||
            value.length < maxLength
          )
          &&
          <div className='add-button-container'>
            <FlatButton
              style={addButtonStyle}
              label='Add Line'
              onClick={this.addValue(finalValue)}
            />
          </div>
        }
        {
          descriptionBottom
          &&
          <div className='bottom-description'>
            {descriptionBottom}
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_TextInputList/index.js